import { NetworkStatus, useQuery } from '@apollo/client'
import { QueryHookOptions } from '@apollo/client/react/types/types'
import {
  UserHoldingsQuery as UserHoldingQueryGQL,
  UserHoldingsQueryVariables,
} from '../types/sx1155/graphql'
import { useMemo } from 'react'
import { UserHoldingsQuery } from '../queries/sx1155/SX1155Holdings'
import sx1155Client from '../clients/sx1155-client'
import { normalizeAllSX1155Holdings } from '../utils/sx1155'

export const PageLimit = 100

const useSX1155Holdings = (
  options?: QueryHookOptions<UserHoldingQueryGQL, UserHoldingsQueryVariables>
) => {
  const { data, loading, error, called, networkStatus, refetch } = useQuery(
    UserHoldingsQuery,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      ...options,
      variables: {
        limit: PageLimit,
        skip: 0,
        filter: options?.variables?.filter,
      },
      client: sx1155Client,
    }
  )

  const sx1155Holdings = useMemo(
    () => normalizeAllSX1155Holdings(data?.userHoldings || []),
    [data?.userHoldings]
  )

  return useMemo(
    () => ({
      sx1155Holdings,
      loading:
        loading ||
        ![
          NetworkStatus.ready,
          NetworkStatus.error,
          NetworkStatus.poll,
        ].includes(networkStatus),
      error,
      called,
      refetching: networkStatus === NetworkStatus.refetch,
      refetch,
    }),
    [sx1155Holdings, loading, networkStatus, error, called, refetch]
  )
}

export default useSX1155Holdings
